import { render, staticRenderFns } from "./ManagersLogs.vue?vue&type=template&id=3ceb2c56"
import script from "./ManagersLogs.vue?vue&type=script&lang=js"
export * from "./ManagersLogs.vue?vue&type=script&lang=js"
import style0 from "./ManagersLogs.vue?vue&type=style&index=0&id=3ceb2c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports